import { Component } from '@angular/core';

@Component({
  selector: 'bids-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.sass']
})
export class LayoutComponent {

  constructor() { }
}
